// Ciro kaydinin proje numarasi — kanaldan bagimsiz.
//
// Ibrahim (kayit 25, 03:03): "Ayni ise bagli bir satis, onay sonrasi,
// yazim giriyorsa mutlaka proje numarasi secilsin, otomatik gelsin...
// Satis mi onay sonrasi mi, hicbir onemi yok."
//
// Onay sonrasi ve yazim kayitlari dogrudan ISE bagli; numara isten
// okunuyor. Satis cirosu ise ise degil SOZLESMEYE bagli, o yuzden
// numarasi hic gelmiyordu. Satis kaydinda numara sozlesmenin islerinden
// geliyor.
//
// Numara kayda KOPYALANMIYOR, her seferinde isten okunuyor: yazim
// onaylanip ise sonradan numara verildiginde o ise bagli eski kayitlarin
// hepsinde kendiliginden gorunur ("kayit olustururken yoksa bile hepsine
// eklenmesi lazim").
//
// DIKKAT: `jobs.project_number` veritabaninda SAYI (integer). Metin gibi
// `.trim()` cagirmak TypeError atiyordu ve bu tek satir butun ciro
// listesini dusuruyordu (useDynamicEntity donusum hatasini da "liste
// alinamadi" diye gosteriyor). Karsilastirma metne cevrilerek yapiliyor.
export const revenueProjectNumber = (row) => {
  const isNo = row?.job?.project_number;
  if (isNo != null && String(isNo).trim() !== '') return isNo;
  const numaralar = [...new Set(
    (row?.contract?.jobs || [])
      .map((j) => (j?.project_number == null ? '' : String(j.project_number).trim()))
      .filter(Boolean),
  )];
  // Sozlesmede birden fazla numarali is varsa hangisine ait oldugu
  // kayittan cikarilamiyor; hepsini gostermek birini rastgele secmekten
  // dogru.
  return numaralar.length ? numaralar.join(', ') : null;
};
